import { makeUclComponent } from '@rbilabs/universal-components';

import { InnerLayout } from 'components/layout/styled';
import { UIRefreshOffers } from 'components/offers/ui-refresh';
import BlockRenderer from 'components/sanity-block-renderer';

import { LoyaltyLoader } from '../loyalty-loader';

export const StyledUIRefreshOffers = makeUclComponent(UIRefreshOffers).withConfig({
  height: 'full',
  width: {
    md: 'full',
  },
  flexDirection: {
    md: 'row',
  },
});

export const StyledBlockRenderer = BlockRenderer.withConfig({
  margin: 0,
  fontSize: 'xs',
});

export const LoyaltyIncentivesContainer = InnerLayout.withConfig({
  paddingY: '$0',
});

export const StyledLoyaltyLoader = LoyaltyLoader;
